import { lazy } from 'react';

export const ErrorPage = lazy(() => import('./ErrorPage'));
export const MainPage = lazy(() => import('./MainPage'));
